import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { Eye, EyeOff, LogIn } from 'lucide-react';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-[#F4F6F9]">
      {/* Sol panel */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-navy-700 via-navy-800 to-navy-900 flex-col justify-between p-12 relative overflow-hidden">
        {/* Dekoratif daireler */}
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-white/3 -translate-y-1/3 translate-x-1/3" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-gold-400/10 translate-y-1/3 -translate-x-1/3" />
        <div className="absolute top-1/2 right-12 w-32 h-32 rounded-full bg-navy-600/50" />

        {/* Logo */}
        <div className="flex items-center gap-3 relative z-10">
          <div className="w-10 h-10 rounded-xl bg-gold-400 flex items-center justify-center">
            <span className="text-navy-900 font-bold text-lg font-display">K</span>
          </div>
          <div>
            <p className="text-white font-semibold">Kanguroo</p>
            <p className="text-navy-400 text-xs">Dijital Ajans</p>
          </div>
        </div>

        {/* Orta metin */}
        <div className="relative z-10">
          <h1 className="font-display text-4xl text-white leading-snug mb-4">
            Firma<br />
            <span className="text-gold-400">Veritabanı</span><br />
            Paneli
          </h1>
          <p className="text-navy-300 text-sm leading-relaxed max-w-xs">
            Firmalarınızı yönetin, içe/dışa aktarın, istatistiklerinizi takip edin.
          </p>
        </div>

        <p className="text-navy-500 text-xs relative z-10">
          © 2025 Kanguroo. Tüm hakları saklıdır.
        </p>
      </div>

      {/* Sağ panel — form */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          {/* Mobile logo */}
          <div className="flex items-center gap-3 mb-8 lg:hidden">
            <div className="w-9 h-9 rounded-xl bg-navy-700 flex items-center justify-center">
              <span className="text-gold-400 font-bold text-base font-display">K</span>
            </div>
            <p className="text-navy-700 font-semibold">Firma Paneli</p>
          </div>

          <h2 className="text-2xl font-display text-navy-800 mb-1">Hoş geldiniz</h2>
          <p className="text-navy-400 text-sm mb-8">Devam etmek için giriş yapın</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label">E-posta</label>
              <input
                type="email"
                className="input"
                placeholder="admin@kanguroo.com.tr"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                required
              />
            </div>

            <div>
              <label className="label">Şifre</label>
              <div className="relative">
                <input
                  type={showPass ? 'text' : 'password'}
                  className="input pr-10"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-navy-400 hover:text-navy-600"
                >
                  {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn-primary w-full justify-center py-2.5 mt-2"
              disabled={loading}
            >
              {loading ? (
                <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
              ) : (
                <LogIn size={16} />
              )}
              {loading ? 'Giriş yapılıyor…' : 'Giriş Yap'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
